import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=5856c553&scoped=true"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"
import style0 from "./TabPane.vue?vue&type=style&index=0&id=5856c553&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856c553",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5856c553')) {
      api.createRecord('5856c553', component.options)
    } else {
      api.reload('5856c553', component.options)
    }
    module.hot.accept("./TabPane.vue?vue&type=template&id=5856c553&scoped=true", function () {
      api.rerender('5856c553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/components/TabPane.vue"
export default component.exports